<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import store from '@/store/index';
  export default {
    data() {
      return {
        locale: zhCN,
        setting: {},
        data:{},
      };
    },
    async mounted() {
      this.data= await store.dispatch('configs/setLogo')
      this.setTitleIcon();

    },
    methods: {
      setTitleIcon() {
        var link = document.querySelector("iframe") || document.createElement('link');
        let $favicon = document.querySelector('iframe');
        if ($favicon !== null) {
          $favicon.href = link;
        } else {
          $favicon = document.createElement('link');
          $favicon.rel = 'icon';
          $favicon.href = 'https://oss.shanghuicn.com' + this.data.www_logo_src;
      
          document.head.appendChild($favicon);
          // document.title = '133';
        }
      },
    },
    created() {},
  };
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
